// extracted by mini-css-extract-plugin
module.exports = {"container":"live-conversations__WaitingForPair__container"};